export function useUserData() {
  const store = useKegelStore();
  async function getUserData() {
    try {
      const response = await fetch('https://ipinfo.io/json');
      const { city, country, postal, region } = await response.json();
      store.userData = { geo_city: city, geo_country: country, geo_postal_code: postal, geo_region: region };
    } catch (error: unknown) {
      console.error('ERROR loading data', error);
    }
  }

  return { getUserData };
}
